import { render } from "./info.vue?vue&type=template&id=a6b2b9be&scoped=true"
import script from "./info.js?vue&type=script&lang=js&external"
export * from "./info.js?vue&type=script&lang=js&external"

import "./info.css?vue&type=style&index=0&id=a6b2b9be&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6b2b9be"]])

export default __exports__